<template>
  <div class="ov-card">
    <div class="ui-head">
      <div class="ui-avatar">{{ initials }}</div>
      <div class="ui-head__text">
        <div class="ui-name">{{ fullName }}</div>
        <div class="ui-email">{{ account && account.email ? account.email : '—' }}</div>
      </div>
      <span v-if="account && account.roleCode" class="ov-badge ov-badge--navy ov-badge--plain">{{ account.roleCode }}</span>
    </div>

    <div class="ov-card__body">
      <div class="ov-stat">
        <span class="ov-stat__label">Nom</span>
        <span class="ov-stat__value">{{ account && account.nom ? account.nom : '—' }}</span>
      </div>
      <div class="ov-stat">
        <span class="ov-stat__label">Prénom(s)</span>
        <span class="ov-stat__value">{{ account && account.prenoms ? account.prenoms : '—' }}</span>
      </div>
      <div class="ov-stat">
        <span class="ov-stat__label">Pseudo</span>
        <span class="ov-stat__value">{{ account && account.login ? account.login : '—' }}</span>
      </div>
      <div class="ov-stat">
        <span class="ov-stat__label">E-mail</span>
        <span class="ov-stat__value">{{ account && account.email ? account.email : '—' }}</span>
      </div>
      <div v-if="account && account.compagnieTransportRaisonSociale" class="ov-stat">
        <span class="ov-stat__label">Compagnie</span>
        <span class="ov-stat__value">{{ account.compagnieTransportRaisonSociale }}</span>
      </div>
      <div v-if="account && account.gareDesignation" class="ov-stat">
        <span class="ov-stat__label">Gare</span>
        <span class="ov-stat__value">{{ account.gareDesignation }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserInfo.vue",
  props: {
    account: {
      type: Object,
      default: null,
    },
  },

  computed: {
    fullName() {
      if (!this.account || !this.account.nom) return '—';
      return [this.account.nom, this.account.prenoms].filter(Boolean).join(' ');
    },

    initials() {
      if (!this.account) return '?';
      return [this.account.nom, this.account.prenoms]
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase())
        .join('') || '?';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../styles/admin/ui";

.ui-head {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px 22px;
  border-bottom: 1px solid $ov-line;
}

.ui-avatar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  font-size: 18px;
  font-weight: 900;
  color: #ffffff;
  background: linear-gradient(135deg, $ov-green, $ov-navy);
}

.ui-head__text {
  flex: 1;
  min-width: 0;
}

.ui-name {
  font-size: 17px;
  font-weight: 800;
  color: $ov-navy;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ui-email {
  font-size: 13px;
  color: $ov-muted;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
